import React, { createContext, useContext, useState, useCallback } from 'react';

// Lightweight cross-page sync for target edits (e.g. manual relevance-score
// overrides saved on TargetDetailPage) so the TargetsPage list reflects the
// change immediately — no page refresh or navigation required.
const TargetSyncContext = createContext(null);

export const TargetSyncProvider = ({ children }) => {
  const [updatedTargets, setUpdatedTargets] = useState({}); // id -> latest target doc

  const syncTarget = useCallback((target) => {
    if (!target?.id) return;
    setUpdatedTargets((prev) => ({ ...prev, [target.id]: target }));
  }, []);

  return (
    <TargetSyncContext.Provider value={{ updatedTargets, syncTarget }}>
      {children}
    </TargetSyncContext.Provider>
  );
};

export const useTargetSync = () =>
  useContext(TargetSyncContext) || { updatedTargets: {}, syncTarget: () => {} };

export default TargetSyncContext;
